// Action Types
import { UPDATE_BANNER } from "./actions";

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BANNER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
